import React, { Fragment, useCallback, useEffect, useState } from "react";
import bankService from "../../../../services/_axiosServices/sweep/bank";
import { Loader, Error } from "../../components";

export default function CollectionScheduleReport() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    await bankService
      .retrieveAll()
      .then((res: any) => {
        // console.log(res);
        setLoading(false);
        setData(res.data);
      })
      .catch((err: any) => {
        setLoading(false);
        setError(true);
        console.log(err.message);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="container-fluid relative animatedParent animateOnce">
      <div className="animated fadeInUpShort go">
        <div className="row my-3 mx-2">
          <h3>
            <b>Commercial Banks - Retrieve All</b>
          </h3>
        </div>
        <div className="card no-b">
          <div className="card-body">
            <div className="card-title">
              <div className="page">
                <div className="page-inner">
                  <div className="btn-toolbar justify-content-between">
                    <div className="btn-group">
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={fetchData}
                      >
                        <i className="fas fa-sync"></i>
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive text-nowrap">
                    {loading && <Loader />}

                    {!loading && !error && (
                      <Fragment>
                        <table className="table table-hover table-content table-striped table-bordered table-sm paged-output">
                          <thead>
                            <tr>
                              <th>#</th>
                              {/* <th>id</th> */}
                              <th>CBN Code</th>
                              <th>Institution Name</th>
                              <th>Short Name</th>
                              <th>Sort Code</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((d: any, i: number) => (
                              <tr key={i}>
                                <th scope="row">{i + 1}</th>
                                {/* <td>{d.id}</td> */}
                                <td>{d.cbnCode}</td>
                                <td>{d.institutionName}</td>
                                <td>{d.shortName}</td>
                                <td>{d.sortCode}</td>
                              </tr>
                            ))}
                            {/* </Fragment>)} */}
                          </tbody>
                        </table>
                      </Fragment>
                    )}

                    {error && !loading && <Error />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
